import {IStore} from "modules/types/store";
import {createSelector} from "reselect";

export const getMessagesState = (store: IStore) => store.messages;

export const getMessageText = createSelector(getMessagesState, ({text}) => text);
